export const planPreview_style = {
  rootSx: {
    width: '100%',
  },
};
